import { colorPalette } from "@command-center-app/utils/colorPalette";
import { Box, Button, Drawer, Grid, Typography } from "@mui/material";
import React from "react";
import GenericButton from "../ui/GenericButton";
import { modalStyle } from "./styles/commonStyles";

interface GenericDrawerProps {
  open: boolean;
  title?: string;
  onClose: () => void;
  onPrimaryAction?: () => void;
  onSecondaryAction?: () => void;
  primaryLabel?: string;
  secondaryLabel?: string;
  children: React.ReactNode;
  anchor?: "left" | "right";
  width?: number | string;
  disableBackdropClick?: boolean;
}

const GenericDrawer: React.FC<GenericDrawerProps> = ({
  open,
  title = "Drawer Title",
  onClose,
  onPrimaryAction,
  onSecondaryAction,
  children,
  anchor = "right",
  width = 1000,
  disableBackdropClick = false,
  primaryLabel = "Create",
}) => {
  return (
    <Drawer
      anchor={anchor}
      open={open}
      onClose={disableBackdropClick ? undefined : onClose}
      PaperProps={{
        sx: { width, display: "flex", flexDirection: "column" },
      }}
    >
      {/* Header */}
      <Grid
        container
        sx={{
          justifyContent: "space-between",
          borderBottom: `1px solid ${colorPalette.colorVeryLightGray}`,
          p: 2,
          alignItems: "center",
        }}
      >
        <Typography sx={modalStyle.headerStyle}>{title} </Typography>
        <Button
          variant="text"
          disableRipple
          onClick={onClose}
          sx={{
            p: 0,
            width: "fit-content",
            justifyContent: "end",
            color: colorPalette.colorPureBlack,
            fontSize: "18px",
            "&:hover": {
              background: "transparent",
            },
          }}
        >
          &times;
        </Button>
      </Grid>
      <Box
        sx={{
          flex: 1,
          overflowY: "auto",
          p: 2,
        }}
      >
        {children}
      </Box>
      <Box
        sx={{
          p: 2,
          display: "flex",
          justifyContent: "flex-end",
          gap: 1,
          borderTop: "1px solid #e0e0e0",
        }}
      >
        {onSecondaryAction && (
          <GenericButton
            text="Cancel"
            variant="outlined"
            onClick={onSecondaryAction}
            textColor={colorPalette.colorAccent}
            backgroundColor="none"
            style={{ borderColor: colorPalette.colorAccent }}
          />
        )}
        {onPrimaryAction && (
          <GenericButton
            variant="contained"
            text={primaryLabel}
            style={{ float: "right" }}
            onClick={onPrimaryAction}
          />
        )}
      </Box>
    </Drawer>
  );
};

export default GenericDrawer;
